import React from 'react';

const Experiences: React.FC = () => {
  return (
    <section className="card" aria-labelledby="audience-experiences">
      <h3 id="audience-experiences">Experiences</h3>
      <div className="cards-grid">
        <div className="small-card">🎤 Talks</div>
        <div className="small-card">🛠 Workshops</div>
        <div className="small-card">🚩 CTFs</div>
        <div className="small-card">🧠 Villages</div>
      </div>
    </section>
  );
};

export default Experiences;